module.exports = __webpack_public_path__ + "img/pain-point-2.9d0d2e3e.svg";